<template>
  <div>
    <doctor-table
      :canDelete="true"
      viewRoute="SuperAdminDoctorEdit"
      viewDetailRoute="SuperAdminDoctorDetail"
      :canCreate="true"
      createRoute="SuperAdminDoctorCreate"
      :canRequestAssociation="true"
    />
  </div>
</template>

<script>
import doctorTable from '../../components/doctors/doctorTable.vue';

export default {
  components: {
    doctorTable,
  },
  data: () => ({}),
};
</script>
